import { call, put, select } from "redux-saga/effects"
import {
  // User Profile
  getUserSuccess,
  getUserFailure,
  updateProfileSuccess,
  updateProfileFailure,
  // Forgot Password
  forgotPasswordSuccess,
  forgotPasswordFailure,
  // Social Login
  socialLoginSuccess,
  socialLoginFailure,
} from "../../actions/auth"
import authApi from "../../../api/auth"
import {
  GET_OTP_FAILURE,
  GET_OTP_PVS_FAILURE,
  GET_OTP_PVS_SUCCESS,
  GET_OTP_SUCCESS,
  GET_ADMIN_DASHBOARD_DATA_FAILURE,
  GET_ADMIN_DASHBOARD_DATA_SUCCESS,
  GET_ALL_INVOICES_FAILURE,
  GET_ALL_INVOICES_SUCCESS,
  GET_USER_DETAILS_FAILURE,
  GET_USER_DETAILS_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  SIGNUP_FAILURE,
  SIGNUP_SUCCESS,
  UPDATE_PROFILE_FAILURE,
  UPDATE_PROFILE_SUCCESS,
} from "../../types/auth"

// Auth utilities
const getAuthToken = state => state.auth.token

// =========== Get OTP Worker ===========
export function* getOTPWorker(action) {
  console.log("getOTPWorker called with:", action)

  try {
    const response = yield authApi.getOTPRequest(action.payload)
    console.log("response", response)
    if (!response) {
      throw new Error("No response from server. Please check your connection.")
    }
    if (response.status === 200) {
      let loginSuccessAction = {
        type: GET_OTP_SUCCESS,
        payload: { msg: response.data?.message },
      }
      yield put(loginSuccessAction)
    } else if (response.status === 400) {
      console.log("error response", response)

      let loginFailureAction = {
        type: GET_OTP_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(loginFailureAction)
    }
  } catch (error) {
    console.log("Login Error", error)
    let otpFailureAction = {
      type: GET_OTP_FAILURE,
      payload: { msg: error.message || "Login failed" },
    }
    yield put(otpFailureAction)
  }
}

// =========== Get all invoices Worker ==========
export function* getAllInvoicesWorker(action) {
  console.log("getAllInvoicesWorker called with:", action)
  const token = yield select(getAuthToken)
  try {
    const response = yield authApi.getAllInvoices(action.payload, token)
    console.log("response", response)

    if (response.status === 200 || response.status === 201) {
      yield put({
        type: GET_ALL_INVOICES_SUCCESS,
        payload: { data: response.data.data || response.data },
      })
    } else {
      yield put({
        type: GET_ALL_INVOICES_FAILURE,
        payload: { error: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: GET_ALL_INVOICES_FAILURE,
      payload: { error: error.message || "Failed to load invoices" },
    })
  }
}

// =========== Get Admin Dashboard Data Worker ==========
export function* getAdminDashboardDataWorker(action) {
  console.log("getAdminDashboardDataWorker called with:", action)
  const token = yield select(getAuthToken)
  try {
    const response = yield authApi.getAdminDashboardData(
      token
    )
    console.log("response", response)
    if (!response) {
      throw new Error("No response from server. Please check your connection.")
    }
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: GET_ADMIN_DASHBOARD_DATA_SUCCESS,
        payload: { data: response.data.data || response.data },
      })
    } else {
      yield put({
        type: GET_ADMIN_DASHBOARD_DATA_FAILURE,
        payload: { error: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: GET_ADMIN_DASHBOARD_DATA_FAILURE,
      payload: { error: error.message || "Failed to load dashboard data" },
    })
  }
}

export function* getOTPPVSWorker(action) {
  console.log("getOTPPVSWorker called with:", action)

  try {
    const response = yield authApi.getOTPPVSRequest(action.payload)
    console.log("response", response)
    if (!response) {
      throw new Error("No response from server. Please check your connection.")
    }
    if (response.status === 200) {
      let successAction = {
        type: GET_OTP_PVS_SUCCESS,
        payload: {
          message: response.data.message,
          pvsOtpResult: response.data.results,
        },
      }
      yield put(successAction)
    } else if (response.status === 400) {
      console.log("error response", response)

      let failureAction = {
        type: GET_OTP_PVS_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    }
  } catch (error) {
    console.log("Login Error", error)
    let otpFailureAction = {
      type: GET_OTP_PVS_FAILURE,
      payload: { msg: error.message || "Something went wrong" },
    }
    yield put(otpFailureAction)
  }
}

// =========== Login Worker ===========
export function* loginWorker(action) {
  console.log("loginWorker called with:", action)

  try {
    const response = yield authApi.login(action.payload)
    console.log("response", response)
    if (!response) {
      throw new Error("No response from server. Please check your connection.")
    }
    if (response.status === 200) {
      let loginSuccessAction = {
        type: LOGIN_SUCCESS,
        payload: {
          user: response.data?.userData?.user,
          token: response.data?.userData?.user?.token,
          dashboard_redirection_type:
            response.data?.userData?.user?.dashboard_redirection_type,
          pvs_cards: response.data?.userData?.pvs_cards,
          awards: response.data?.userData?.awards,
        },
      }
      yield put(loginSuccessAction)
    } else if (response.status === 400) {
      console.log("error response", response)

      let loginFailureAction = {
        type: LOGIN_FAILURE,
        payload: { error: response.data?.message || "Login failed" },
      }
      yield put(loginFailureAction)
    }
  } catch (error) {
    console.log("Login Error", error)
    let loginFailureAction = {
      type: LOGIN_FAILURE,
      payload: { msg: error.message || "Login failed" },
    }
    yield put(loginFailureAction)
  }
}

// =========== Signup Worker ===========
export function* signupWorker(action) {
  console.log("signupWorker called with:", action)

  try {
    const response = yield authApi.signup(action.payload)
    console.log("response", response)
    if (!response) {
      throw new Error("No response from server. Please check your connection.")
    }
    if (response.status === 200) {
      let signupSuccessAction = {
        type: SIGNUP_SUCCESS,
        payload: {
          user: response.data?.userData?.user,
          token: response.data?.userData?.user?.token,
          dashboard_redirection_type:
            response.data?.userData?.user?.dashboard_redirection_type,
          pvs_cards: response.data?.userData?.pvs_cards,
          awards: response.data?.userData?.awards,
        },
      }
      yield put(signupSuccessAction)
    } else if (response.status === 400) {
      console.log("error response", response)

      let loginFailureAction = {
        type: SIGNUP_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(loginFailureAction)
    }
  } catch (error) {
    console.log("Login Error", error)
    let loginFailureAction = {
      type: SIGNUP_FAILURE,
      payload: { msg: error.message || "Login failed" },
    }
    yield put(loginFailureAction)
  }
}

// =========== Get user details Worker ===========
export function* getUserdetailsWorker(action) {
  console.log("getUserdetailsWorker called with:", action)
  const token = yield select(getAuthToken)
  try {
    const response = yield authApi.getUserDetails(token)
    console.log("response", response)
    if (!response) {
      throw new Error("No response from server. Please check your connection.")
    }
    if (response.status === 200) {
      let userDetailsSuccessAction = {
        type: GET_USER_DETAILS_SUCCESS,
        payload: {
          user: response.data?.user?.user,
          pvs_cards: response.data?.user?.pvs_cards,
          awards: response.data?.user?.awards,
          all_activity_list: response.data?.user?.all_activity_list,
        },
      }
      yield put(userDetailsSuccessAction)
    } else if (response.status === 400) {
      console.log("error response", response)

      let userDetailsFailureAction = {
        type: GET_USER_DETAILS_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(userDetailsFailureAction)
    }
  } catch (error) {
    console.log("User Details Error", error)
    let userDetailsFailureAction = {
      type: GET_USER_DETAILS_FAILURE,
      payload: { msg: error.message || "User Details failed" },
    }
    yield put(userDetailsFailureAction)
  }
}

// =========== Get User Worker ===========
export function* getUserWorker() {
  try {
    // Check if user is authenticated
    const token = yield select(getAuthToken)
    if (!token) {
      throw new Error("Not authenticated")
    }

    const user = yield call(authApi.getCurrentUser)
    yield put(getUserSuccess(user))
  } catch (error) {
    yield call(removeAuthToken)
    yield put(getUserFailure(error.message || "Failed to fetch user data"))
  }
}

// =========== Update Profile Worker ===========
export function* updateProfileWorker(action) {
  console.log("updateProfileWorker called with:", action)

  try {
    const { user } = action.payload
    const token = yield select(getAuthToken)
    const response = yield authApi.updateProfile(user, token)
    console.log("update profile response", response)
    if (!response) {
      throw new Error("No response from server. Please check your connection.")
    }
    if (response.status === 200) {
      let userDetailsSuccessAction = {
        type: UPDATE_PROFILE_SUCCESS,
        payload: {
          user: response.data.userData.user,
          pvs_cards: response.data.userData.pvs_cards,
          awards: response.data.userData.awards,
        },
      }
      yield put(userDetailsSuccessAction)
    } else {
      throw new Error(
        (response.data && response.data.message) || "Failed to update profile"
      )
    }
  } catch (error) {
    let updateProfileFailureAction = {
      type: UPDATE_PROFILE_FAILURE,
      payload: { error: error.message || "Failed to update profile" },
    }
    yield put(updateProfileFailureAction)
  }
}

// =========== Forgot Password Worker ===========
export function* forgotPasswordWorker(action) {
  try {
    const { email } = action.payload
    const response = yield call(authApi.forgotPassword, email)

    if (response.success) {
      yield put(forgotPasswordSuccess(response.message))
    } else {
      throw new Error(
        response.message || "Failed to process forgot password request"
      )
    }
  } catch (error) {
    yield put(
      forgotPasswordFailure(
        error.message || "Failed to send password reset email"
      )
    )
  }
}

// =========== Social Login Worker ===========
export function* socialLoginWorker(action) {
  try {
    const { data, history, type } = action.payload
    const response = yield call(
      authApi.socialLogin,
      type,
      data.accessToken || data.idToken
    )

    if (response.success) {
      yield call(setAuthToken, response.token)
      yield put(socialLoginSuccess(response))

      // Redirect after successful social login
      if (history) {
        history.push("/dashboard")
      }
    } else {
      throw new Error(response.message || "Social login failed")
    }
  } catch (error) {
    yield put(socialLoginFailure(error.message || "Social login failed"))
  }
}
